import { buildAgentQuestionAssistantMessagePatch } from '@/features/chat/agentQuestion/buildAgentQuestionAssistantMessagePatch.js'
import { scaleChatStreamDelay } from '../streaming/chatStreamSpeed.js'

/** @param {import('./runResponseComponentDemoStream.js').DemoStreamCtx} ctx */
export function runAgentQuestionTurn(ctx) {
  const { tid, pendingId, signal, session, setMessagesByThreadId } = ctx

  session.addTimeout(() => {
    if (signal.aborted) {
      session.dispose()
      return
    }
    setMessagesByThreadId((inner) => {
      const list = [...(inner[tid] ?? [])]
      const idx = list.findIndex((m) => m.id === pendingId)
      if (idx === -1) return inner
      const next = [...list]
      const prev = list[idx]
      const started =
        typeof prev.thinkingStartedAt === 'number' ? prev.thinkingStartedAt : prev.createdAt
      const { patch } = buildAgentQuestionAssistantMessagePatch(started)
      next[idx] = { ...next[idx], ...patch }
      return { ...inner, [tid]: next }
    })
    session.dispose()
  }, scaleChatStreamDelay(500))
}
